<template>
  <a-modal class="date-modal-css" v-model="showApprove" :title="status==='approve'?'审核':'驳回'" width="450px" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
      <a-form-item label="审批意见" v-if="status==='approve'">
        <a-input v-model="comment" style="width: 310px" :maxLength="200" />
      </a-form-item>
      <div v-else>确认驳回后即整单驳回，请确认</div>
    </a-form>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="btnLoading" @click="onSubmit">确定</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'ApproveModal',
  data () {
    return {
      status: '', // 判断同意还是驳回
      loading: false,
      showApprove: false,
      comment: '' // 审批意见
    }
  },
  props: {
    btnLoading: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    // 确认审批
    onSubmit() {
      this.loading = true
      this.$emit('afterApprove', { comment: this.comment, status: this.status })
      // this.showApprove = false
    },
    show(status) {
      this.loading = false
      this.status = status
      this.comment = ''
      this.showApprove = true
    },
    onCancel() {
      this.comment = ''
      this.showApprove = false
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.approval-input {
input {
  width: 400px;
}
}

</style>
